import React from "react";
import { FormattedMessage } from "react-intl";
import { TextValidationField } from "../fields/TextField";
import PropTypes from "prop-types";
import { defineMessage } from "react-intl";
import { emailValidator } from "./EmailValidator";

export const emailMessages = {
  emailsMustNotMatch: defineMessage({
    id: "emailMessages.emailsMustNotMatch",
    defaultMessage: "New email address must be different from the current email address",
    description: "Error message for email field"
  }),
  emailMustBeValid: defineMessage({
    id: "emailMessages.emailMustBeValid",
    defaultMessage: "This email appears invalid",
    description: "Error message for email field"
  })
}

export const EmailEntry = (props) => {

  return (
    <TextValidationField
      label={<FormattedMessage id="login.emailAddress" defaultMessage="Email Address" description="Label for email address field" />}
      name="email"
      validator={emailValidator}
      {...props}
    />
  );
};


EmailEntry.propTypes = {
  onChange: PropTypes.func,
  externalValue: PropTypes.string,
};

